module.exports = __webpack_public_path__ + "img/teach-america-logo.2af7e523.jpg";